module.exports = __webpack_public_path__ + "img/guessSu.585007ad.svg";